export const IntegrationStep = {
  None: 'none',
  Connect: 'connect',
  Confirm: 'confirm',
  Confirmed: 'confirmed',
  Disconnect: 'disconnect',
  Disconnected: 'disconnected',
} as const;
export type IntegrationStep = (typeof IntegrationStep)[keyof typeof IntegrationStep];
